import React from "react";
import { NativeBaseProvider, extendTheme } from "native-base";
import Theme from "./src/argon-ui/Theme";

const Wrapper = ({ children }) => {
  const theme = extendTheme({
    colors: {
      ...Theme.COLORS,
      primary: Theme.COLORS.MONOCHROME.PRIMARY,
      // primary: Theme.COLORS.PRIMARY,
      // secondary:Theme.COLORS.SECONDARY,
      // dark:Theme.COLORS.DARK,
      error: {
        600: Theme.COLORS.ERROR,
      },
      muted: {
        600: "#767676",
      },
    },
    fonts: {
      heading: "IRANSansWebFaNum",
      body: "IRANSansWebFaNum",
      mono: "IRANSansWebFaNum",
    },
  });
  return <NativeBaseProvider theme={theme}>{children}</NativeBaseProvider>;
};

export default Wrapper;
